import dayjs from "dayjs";
import { useGetOrganization } from "../../../../../../api/v1";
import { resolveBreakdownMode } from "../../../../BookingForm/components/Commercial/add-plan";
import { useBookingSelector } from "../../../../BookingForm/hooks/useBookingSelector";
import { hasTorRules } from "../../../../BookingForm/utils";
import { useTorRules } from "../../../../BookingForm/hooks/useTorRules";

export const usePaymentPlansYearLimit = () => {
  const bookingDetails = useBookingSelector();
  const { organization } = useGetOrganization();
  const { isBaseRentOnly } = useTorRules();

  // Only baseRentOnly can use paymentSchedule; all other lease types call monthlyBillingSchedule with billingSchedule.
  const selectedBreakdownMode = isBaseRentOnly ? resolveBreakdownMode(bookingDetails?.generate) : "billingSchedule";

  const isSeparateInvoicingEnabled = Boolean(organization?.monthlyBillingBreakdownAndTorSeparateInvoicing);

  const leaseYearDifference =
    dayjs(bookingDetails?.leaseTerms?.leaseEndDate).diff(dayjs(bookingDetails?.leaseTerms?.leaseStartDate), "year") + 1;

  const yearLimit = bookingDetails?.bookingTerms?.numberOfRenewalTerms ?? leaseYearDifference;

  const isleaseTypeTor = hasTorRules(bookingDetails?.torType);

  return {
    bookingDetails,
    selectedBreakdownMode,
    yearLimit,
    isSeparateInvoicingEnabled,
    isleaseTypeTor,
    leaseId: bookingDetails?.leaseId,
    torType: bookingDetails?.torType,
  };
};
